import { Check } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

export function Checkbox(props: {
  isChecked: boolean;
  disabled?: boolean;
}) {
  return (
    <div role="checkbox" aria-checked={props.isChecked} aria-disabled={props.disabled} className="mr-0 flex size-6 items-center p-1">
      {props.isChecked ? (
        <div
          className={twMerge(
            'size-4 rounded-[2px] border-2',
            'flex items-center justify-center',
            'bg-chariot-brand-primary border-chariot-brand-primary',
            props.disabled && 'opacity-50 hover:cursor-not-allowed'
          )}
        >
          <Check className="size-3 stroke-[3px] text-white" />
        </div>
      ) : (
        <div
          className={twMerge(
            'size-4 rounded-[2px] border-2',
            'border-chariot-text-secondary bg-transparent',
            props.disabled && 'opacity-50 hover:cursor-not-allowed'
          )}
        />
      )}
    </div>
  );
}
